import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xxl-8" }
const _hoisted_4 = { class: "col-xxl-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xxl-12 col-md-6" }
const _hoisted_7 = { class: "col-xxl-12 col-md-6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-7 col-xxl-6" }
const _hoisted_10 = { class: "col-lg-5 col-xxl-6" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-xxl-4" }
const _hoisted_13 = { class: "col-xxl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Overview = _resolveComponent("Overview")!
  const _component_InboundCallsChart = _resolveComponent("InboundCallsChart")!
  const _component_OutboundCallsChart = _resolveComponent("OutboundCallsChart")!
  const _component_AgentsPerformanceOverview = _resolveComponent("AgentsPerformanceOverview")!
  const _component_CallCenterGeography = _resolveComponent("CallCenterGeography")!
  const _component_AgentAvgEarnings = _resolveComponent("AgentAvgEarnings")!
  const _component_RecentCalls = _resolveComponent("RecentCalls")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Overview)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_InboundCallsChart)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_OutboundCallsChart)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_AgentsPerformanceOverview)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_CallCenterGeography)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_AgentAvgEarnings)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_RecentCalls)
      ])
    ])
  ]))
}